export default "__VITE_ASSET__kwi04ZkV__"